import { IconSize } from '@constants';
import { Box, styled } from '@mui/material';

interface VideoThumbnailContainerStyledProps {
  selected?: boolean;
}

export const VideoThumbnailContainerStyled = styled(
  Box,
)<VideoThumbnailContainerStyledProps>(({ theme, selected }) => ({
  borderRadius: theme.spacing(0.5),
  border: `2px solid transparent`,
  borderColor: selected ? theme.palette.primary.main : 'transparent',
  flex: 1,
  height: 110,
  overflow: 'hidden',
  cursor: 'pointer',
  position: 'relative',

  '& img': {
    objectFit: 'cover',
    height: '100%',
    width: '100%',
  },
}));

export const CheckMarkStyled = styled(Box)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  bottom: 12,
  left: 12,
  background: theme.palette.primary.main,

  borderRadius: '50%',
  height: IconSize.md,
  width: IconSize.md,
}));
